import Block from 'components/Block'
import TextBody from 'components/TextBody'
import TextTitleCompressedHeavy from 'components/TextTitleCompressedHeavy'
import TextTitleCompressedHeavyUpperCase from 'components/TextTitleCompressedHeavyUpperCase'
import { View } from 'components/View'
import formatMessageIntlUtil from 'modules/intl/utils/format-message'
import { STYLES_FONT_SIZE } from 'modules/styles/constants/index.cjs'
import React from 'react'
import { defineMessages } from 'react-intl'
import useIntl from 'modules/component/utils/hooks/useIntl'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import isSmallScreenViewportSelect from 'modules/viewport/selectors/is-small-screen'
import { useTheme } from 'modules/styles/index.js'
import { WhoItsBuiltForCTA } from './Cta'

const messages = defineMessages({
  title: {
    id: 'CheckExerciseFormWhoItsBuiltFor.title',
    defaultMessage: 'Who Gymaholic Is Built For'
  },
  beginners: {
    id: 'CheckExerciseFormWhoItsBuiltFor.beginners',
    defaultMessage: 'Beginners'
  },
  beginnersDescription: {
    id: 'CheckExerciseFormWhoItsBuiltFor.beginnersDescription',
    defaultMessage: 'New to lifting and don’t know if you’re doing it right? Get instant AI feedback on your form to build confidence and avoid bad habits.'
  },
  betweenTrainers: {
    id: 'CheckExerciseFormWhoItsBuiltFor.betweenTrainers',
    defaultMessage: 'Between Trainers'
  },
  betweenTrainersDescription: {
    id: 'CheckExerciseFormWhoItsBuiltFor.betweenTrainersDescription',
    defaultMessage: 'Taking a break from your personal trainer? Keep your form in check with AI-powered coaching until you’re ready to return.'
  },
  recoveringFromInjury: {
    id: 'CheckExerciseFormWhoItsBuiltFor.recoveringFromInjury',
    defaultMessage: 'Recovering From Injury'
  },
  recoveringFromInjuryDescription: {
    id: 'CheckExerciseFormWhoItsBuiltFor.recoveringFromInjuryDescription',
    defaultMessage: 'Getting back to lifting after an injury? Ensure you’re using proper form to prevent re-injury and rebuild strength safely.'
  },
  seriousLifters: {
    id: 'CheckExerciseFormWhoItsBuiltFor.seriousLifters',
    defaultMessage: 'Serious Lifters'
  },
  seriousLiftersDescription: {
    id: 'CheckExerciseFormWhoItsBuiltFor.seriousLiftersDescription',
    defaultMessage: 'Optimize every rep and lift heavier safely. Get precise AI feedback to perfect your technique and maximize your gains.'
  }
})

const PERSONAS = [
  {
    titleMessage: messages.beginners,
    descriptionMessage: messages.beginnersDescription,
    icon: '🌟'
  },
  {
    titleMessage: messages.betweenTrainers,
    descriptionMessage: messages.betweenTrainersDescription,
    icon: '🎯'
  },
  {
    titleMessage: messages.recoveringFromInjury,
    descriptionMessage: messages.recoveringFromInjuryDescription,
    icon: '🏥'
  },
  {
    titleMessage: messages.seriousLifters,
    descriptionMessage: messages.seriousLiftersDescription,
    icon: '🏋️'
  }
]

export function CheckExerciseFormWhoItsBuiltFor () {
  const isSmallScreen = useSelector(isSmallScreenViewportSelect)
  const intl = useIntl()
  const theme = useTheme()

  return (
    <Block
      bgc='backgroundContent'
    >
      <View
        centered
        style={{
          maxWidth: theme.maxWidth.desktopCompact
        }}
      >
        <View
          mb={4}
          style={{
            textAlign: 'center'
          }}
        >
          <TextTitleCompressedHeavy>
            {formatMessageIntlUtil(intl, messages.title)}
          </TextTitleCompressedHeavy>
        </View>
        <View
          row={!isSmallScreen}
          wrap
          style={{
            gap: isSmallScreen ? '1em' : '1.5em'
          }}
        >
          {
            PERSONAS.map((persona, index) => {
              const {
                titleMessage,
                descriptionMessage,
                icon
              } = persona
              return (
                <View
                  key={index}
                  f
                  p={3}
                  style={{
                    backgroundColor: 'white',
                    borderRadius: '0.5em',
                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                    flex: isSmallScreen ? '1 1 100%' : '1 1 calc(50% - 0.75em)',
                    textAlign: 'left'
                  }}
                >
                  <View
                    mb
                    style={{
                      fontSize: '2.5em'
                    }}
                  >
                    {icon}
                  </View>
                  <TextTitleCompressedHeavyUpperCase
                    mb
                    style={{
                      fontSize: STYLES_FONT_SIZE.HEADING_SMALL
                    }}
                  >
                    {formatMessageIntlUtil(intl, titleMessage)}
                  </TextTitleCompressedHeavyUpperCase>
                  <TextBody>
                    {formatMessageIntlUtil(intl, descriptionMessage)}
                  </TextBody>
                </View>
              )
            })
          }
        </View>
        <View
          mt={4}
          centered
          style={{
            textAlign: 'center'
          }}
        >
          <WhoItsBuiltForCTA />
        </View>
      </View>
    </Block>
  )
}
